import styles from '../PickUpOrderView.module.scss';
import cn from 'classnames';
import { IPickUpOrderViewPointProps } from '../types';
import { Text, TextColor, TextSize, TextWeight } from '@components/Text';

const PickUpOrderViewPoint: React.FC<IPickUpOrderViewPointProps> = (props: IPickUpOrderViewPointProps): React.ReactElement => {
  const { label, titleColor, value, width, withBorder } = props;

  return (
      <div
          className={cn(
              styles.orderPoint,
              withBorder && styles.orderPointWithBorder,
              !width && styles.orderPointAutoWidth
          )}
          style={{ width }}
      >
        <Text
            color={titleColor || TextColor.DARK_MUTED}
            size={TextSize.XS}
            weight={TextWeight.SEMIBOLD}
        >
          {label}
        </Text>
        {value}
      </div>
  );
};

export default PickUpOrderViewPoint;